import { render, staticRenderFns } from "./MessageDetail.vue?vue&type=template&id=74147769&scoped=true"
import script from "./MessageDetail.vue?vue&type=script&lang=js"
export * from "./MessageDetail.vue?vue&type=script&lang=js"
import style0 from "./MessageDetail.vue?vue&type=style&index=0&id=74147769&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74147769",
  null
  
)

export default component.exports